export default __webpack_public_path__ + "static/media/onboarding-en.e745fe44.mp4";